import { ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/locale/zh_TW';
import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

interface I18nProviderProps {
  children: ReactNode;
}

const I18nProvider = ({ children }: I18nProviderProps) => {
  const { i18n } = useTranslation();

  const getAntdLocale = () => {
    switch (i18n.language) {
      case 'en':
        dayjs.locale('en');
        return enUS;
      case 'ja':
        dayjs.locale('ja');
        return jaJP;
      case 'zh':
      default:
        dayjs.locale('zh-tw');
        return zhTW;
    }
  };

  const antdConfig = {
    locale: getAntdLocale(),
    theme: {
      token: {
        colorPrimary: '#1890ff',
        borderRadius: 6,
      },
    },
  };

  return (
    <ConfigProvider {...antdConfig}>
      {children}
    </ConfigProvider>
  );
};

export default I18nProvider;